import styled from "styled-components";
import { useState } from "react";
import { Form, Button, Select } from "library";
import { Body4 } from "components/Typography";

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

interface Paso2ExistenteProps {
  inscrito: {
    id: number | string;
    nombre: string;
    identificacion: string;
    pais?: string;
  };
  tallerActualId?: number;
  talleres: { label: string; value: number; disabled?: boolean }[];
  onFinish: (values: { taller?: number }) => void;
  onBack: () => void;
  onRefreshTalleres?: () => void;
  isSubmitting?: boolean;
}

/** Persona ya inscrita: solo seleccionar / cambiar taller. */
export function Paso2Existente({
  inscrito,
  tallerActualId,
  talleres,
  onFinish,
  onBack,
  onRefreshTalleres,
  isSubmitting = false,
}: Paso2ExistenteProps) {
  const [tallerSeleccionado, setTallerSeleccionado] = useState<
    number | undefined
  >(tallerActualId);
  const puedeGuardar =
    tallerSeleccionado != null && tallerSeleccionado !== tallerActualId;

  const talleresConActual = talleres.map((t) => ({
    ...t,
    // Permitir mantener el taller ya asignado aunque no tenga cupos libres
    disabled: t.disabled && t.value !== tallerActualId,
  }));

  return (
    <FormContainer>
      <MensajeInscrito>
        <strong>{inscrito.nombre}</strong>, identificación{" "}
        <strong>{inscrito.identificacion}</strong>, ya se encuentra inscrito en el 
        <strong> EIDU</strong>.
      </MensajeInscrito>
      <LeyendaTaller>
        {tallerActualId
          ? "Ya tiene un taller asignado. Seleccione otro para actualizarlo."
          : "Aún no ha seleccionado taller. Debe elegir uno para continuar."}
      </LeyendaTaller>
      <Form
        {...formItemLayout}
        onFinish={onFinish}
        name="eidu-prueba-paso2-existente"
        initialValues={{ taller: tallerActualId }}
        style={{ maxWidth: 480 }}
        onValuesChange={(changed) => {
          if ("taller" in changed) {
            setTallerSeleccionado(
              changed.taller != null ? Number(changed.taller) : undefined
            );
          }
        }}
      >
        <Form.Item
          label="Talleres de formación"
          name="taller"
          rules={[{ required: true, message: "Seleccione un taller" }]}
        >
          <Select
            allowClear
            options={talleresConActual}
            placeholder="Seleccionar un taller"
            onDropdownVisibleChange={(open: boolean) => {
              if (open) onRefreshTalleres?.();
            }}
          />
        </Form.Item>
        <Body4 style={{ color: "#65696A", marginBottom: 24 }}>
          Si desea participar en alguno de los talleres, puede solicitar un cupo
          en esta sección. Todos los talleres serán a las 8:30 a.m. Costa Rica |
          9:30 a.m. Colombia. Los talleres tienen un cupo limitado y se asignan
          por orden de solicitud. Las personas seleccionadas recibirán un correo
          de confirmación. Las personas que no asistan a los talleres, tendrán
          la oportunidad de participar en las Salas de demostraciones (demos) de
          acuerdo a su interés.
        </Body4>
        <ButtonContainer>
          <Button onClick={onBack} variant="secondary">
            Volver
          </Button>
          <Button htmlType="submit" disabled={isSubmitting || !puedeGuardar}>
            {isSubmitting ? "Guardando..." : "Guardar taller"}
          </Button>
        </ButtonContainer>
      </Form>
    </FormContainer>
  );
}

const MensajeInscrito = styled.p`
  font-size: 18px;
  line-height: 26px;
  margin: 0 0 8px;
  color: #000;
`;

const LeyendaTaller = styled.p`
  font-size: 18px;
  line-height: 26px;
  margin: 0 0 48px;
  color: #65696a;
`;

const FormContainer = styled.div`
  .ant-form-item {
    margin-bottom: 24px;
  }
  .ant-form-item-label {
    padding-bottom: 0;
  }
  label {
    font-size: 12px;
    line-height: 19px;
    font-weight: bold;
    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  button {
    flex: 1;
  }
`;
